import { Box, type BoxProps } from '@tempmee/react';

/**
 * Page-level wrapper built on the DS `Box` primitive: centers its content (via
 * the shared `component_container` layout) and paints the DS `background.subdued`
 * page background (`bg-background-subdued` — the `background.subdued` token) so a
 * page matches the content panes that float on it.
 *
 * Replaces the legacy raw `.component_container` div + hardcoded `#E9F1F4`
 * background, keeping the page background defined in one place instead of
 * repeated per screen. Extra `className` is appended and all other props
 * (`style`, `data-cy`, …) are forwarded to the underlying element.
 */
export const PageContainer = ({ className, children, ...rest }: BoxProps) => (
  <Box
    className={`component_container bg-background-subdued${className ? ` ${className}` : ''}`}
    {...rest}
  >
    {children}
  </Box>
);
